// src/components/StructuredData.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Component for injecting JSON-LD structured data into the page
 */
const StructuredData = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};

// Mobile Application Structured Data
export const MobileAppStructuredData = () => {
  const appData = {
    "@context": "https://schema.org",
    "@type": "MobileApplication",
    "name": "AuLedger",
    "description": "AuLedger helps you track your gold collection with real-time market prices, monitor gold investments, calculate current values based on weight and purity, and view historical gold price charts.",
    "applicationCategory": "FinanceApplication",
    "operatingSystem": "iOS",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "124"
    },
    "screenshot": [
      {
        "@type": "ImageObject",
        "contentUrl": "https://auledgerapp.com/assets/portfolio-view.jpg",
        "description": "Portfolio summary view showing gold collection value"
      },
      {
        "@type": "ImageObject",
        "contentUrl": "https://auledgerapp.com/assets/gold-chart.jpg",
        "description": "Historical gold price chart"
      },
      {
        "@type": "ImageObject",
        "contentUrl": "https://auledgerapp.com/assets/item-detail.jpg",
        "description": "Detailed view of a gold item with photos and specifications"
      }
    ],
    "author": {
      "@type": "Organization",
      "name": "AuLedger",
      "url": "https://auledgerapp.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://auledgerapp.com/assets/logo-inline.png"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "contact@auledgerapp.com",
        "contactType": "customer service"
      }
    },
    "inLanguage": "en-US"
  };

  return <StructuredData data={appData} />;
};

// Organization Structured Data
export const OrganizationStructuredData = () => {
  const orgData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AuLedger",
    "url": "https://auledgerapp.com",
    "logo": "https://auledgerapp.com/assets/logo-inline.png",
    "sameAs": [
      "https://twitter.com/auledgerapp",
      "https://www.facebook.com/auledgerapp",
      "https://www.instagram.com/auledgerapp"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "contact@auledgerapp.com",
      "contactType": "customer service"
    }
  };

  return <StructuredData data={orgData} />;
};

// FAQ Page Structured Data
export const FAQStructuredData = ({ faqs }) => {
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return <StructuredData data={faqData} />;
};

export default StructuredData;